import React from 'react'
import PropTypes from 'prop-types'
import ParticlesOverlay from 'components/LayoutComponents/ParticlesOverlay'
import { useTranslate } from 'services/utils'
import { Button } from 'antd'
import PageLoader from 'components/GeneralComponents/Loaders/PageLoader'

const MigrationNotice = ({
  loading,
  id = 'error',
  idText = 'error',
  onClick,
  action,
  cancel,
  cancelOnClick,
}) => {
  const translate = useTranslate()
  return (
    <ParticlesOverlay>
      <main style={{ marginLeft: '-25%' }}>
        <div className="d-inline-block pt-5 pb-5 mt-5 mb-5">
          <h1 className="mb-4">{translate(`pageNotice.${id}`)}</h1>
          <div className="mb-4">{translate(`pageNotice.${idText}`)}</div>
          <div className="d-inline-block">
            {action && (
              <Button size="large" onClick={onClick}>
                {translate(`pageNotice.${action}`)}
              </Button>
            )}
            {cancel && (
              <div className="mt-2">
                <Button dize="small" onClick={cancelOnClick}>
                  {translate(`pageNotice.${cancel}`)}
                </Button>
              </div>
            )}
          </div>
          {loading && <PageLoader />}
        </div>
      </main>
    </ParticlesOverlay>
  )
}

MigrationNotice.defaultProps = {
  onClick: undefined,
  action: null,
  loading: false,
}

MigrationNotice.propTypes = {
  id: PropTypes.string.isRequired,
  action: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
}

export default MigrationNotice
